/* -------------------------------------------------------------------------- */
/*                             Schema Sensor Models                           */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const sensorModel = new schema.Entity('sensorModels', {}, { idAttribute: 'sensorModelId' });
export const sensorModels = new schema.Array(sensorModel);
